// Cross-platform navigation bus: lets chat/social cards jump to the exact
// marketplace product or social post (ChatApp listens for "rc-goto").
export function openProduct(id) {
  if (!id) return;
  window.dispatchEvent(new CustomEvent("rc-goto", { detail: { kind: "product", id } }));
}
export function openPost(id) {
  if (!id) return;
  window.dispatchEvent(new CustomEvent("rc-goto", { detail: { kind: "post", id } }));
}

// Build a public, shareable link that shows a guest preview + register CTA.
export function shareLink(kind, id) {
  return `${window.location.origin}/${kind === "product" ? "p" : "post"}/${id}`;
}
